import axios from 'axios'
import { useSenhaStore } from "@/stores/senha"

export const state = {
    loadingLogInOut: false,
    finalizando: false,
    multiAtendimentoSplash: false,
    splash: false,
    guicheSelectedGlobal: {}
}

export const mutations = {
    SET_LOADING_LOG_IN_OUT(state, status) {
        state.loadingLogInOut = status
    },
    SET_FINALIZANDO(state, status) {
        state.finalizando = status
    },
    SET_MULTI_ATENDIMENTO_SPLASH(state, status) {
        state.multiAtendimentoSplash = status
    },
    SET_SPLASH(state, status) {
        state.splash = status
    },
    SET_GUICHE_SELECTED_GLOBAL(state, payload) {
        state.guicheSelectedGlobal = payload
    }
}

export const getters = {
    getGuicheSelectedGlobal(state) {
        return state.guicheSelectedGlobal
    },
}

export const actions = {
    async liberarGuiche(_, guiche) {
        return await axios
            .post(
                `/privado/atendimento/guiche/${guiche.idGuiche}/logout`
            ).then(() => {
                const senhaStore = useSenhaStore()
                senhaStore.updateSenhaTotemCollection();
            }).catch(() => {})
    },

    changeLoadingLogInOut({ commit }, status) {
        commit('SET_LOADING_LOG_IN_OUT', status)
    },

    changeFinalizando({ commit }, status) {
        commit('SET_FINALIZANDO', status)
    },

    changeMultiAtendimentoSplash({ commit }, status) {
        commit('SET_MULTI_ATENDIMENTO_SPLASH', status)
    },

    changeSplash({ commit }, status) {
        commit('SET_SPLASH', status)
    },

    changeGuicheSelectedGlobal({ commit }, payload) {
        commit('SET_GUICHE_SELECTED_GLOBAL', payload)
    },
}